import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FilterConfig } from '../../../models/filter-config';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-site-toolkit-filters',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './site-toolkit-filters.component.html',
  styleUrl: './site-toolkit-filters.component.scss'
})
export class SiteToolkitFiltersComponent {
  @Input() filterConfig!: FilterConfig;
  @Input() defaultValue = 'not_selected';
  @Output() filterChange = new EventEmitter<FilterConfig>();

  uniqueId = `filter-${Math.random().toString(36).substr(2, 9)}`;

  onChange(event: Event) {
    this.filterConfig.selectedValue = (event.target as HTMLInputElement).checked ? this.filterConfig.options[0] : '';
    this.filterChange.emit(this.filterConfig);
  }
}
